class CartTool extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelectorAll(".cartTool-item");
    e.forEach((e) => {
      e.addEventListener("click", (e) => {
        let t = e.target.dataset.popup;
        document.getElementById(t).classList.add("show"),
          document.querySelector(".previewCart").classList.add("active-tool");
      });
    });
  }
}
customElements.define("cart-item-tool", CartTool);
class CartCancel extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("button").addEventListener("click", (e) => {
        document.querySelector(".popup-toolDown.show").classList.remove("show"),
          document
            .querySelector(".previewCart")
            .classList.remove("active-tool");
      });
  }
}
customElements.define("cart-cancel-popup", CartCancel);
class CartNote extends HTMLElement {
  constructor() {
    super(),
      this.querySelector("[data-update-note]").addEventListener(
        "click",
        (e) => {
          this.val = this.querySelector(".text-area").value;
          let t = JSON.stringify({ note: this.val });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: t }),
            document
              .querySelector(".popup-toolDown.show")
              .classList.remove("show"),
            document
              .querySelector(".previewCart")
              .classList.remove("active-tool");
        }
      );
  }
}
customElements.define("cart-note", CartNote);
class CouponCode extends HTMLElement {
  constructor() {
    super(),
      localStorage.getItem("storedDiscount") &&
        (this.querySelector('input[name="discount"]').value =
          localStorage.getItem("storedDiscount")),
      this.querySelector("[data-update-coupon]").addEventListener(
        "click",
        (e) => {
          (this.val = this.querySelector('input[name="discount"]').value),
            localStorage.setItem("storedDiscount", this.val),
            fetch(`/discount/${this.val}`)
              .then((e) => e.text())
              .then((e) => {}),
            document
              .querySelector(".popup-toolDown.show")
              .classList.remove("show"),
            document
              .querySelector(".previewCart")
              .classList.remove("active-tool");
        }
      );
  }
}
customElements.define("coupon-code", CouponCode);
